<script>
import menuToggle from '../components/menu-toggle.vue';

export default {
    components: {
        'menu-toggle': menuToggle
    }
};
</script>
